import { LitElement } from 'lit';
import { applyThemeTokens } from '@landi/store-core';

declare global {
  interface Window {
    LANDI_STORE_THEME?: unknown;
  }
}

/** Reads embed theme globals injected by publish bootstrap or page script. */
export function readEmbedThemeFromWindow(): unknown {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.LANDI_STORE_THEME;
}

/** Applies `window.LANDI_STORE_THEME` CSS vars on a storefront custom element host. */
export function applyEmbedThemeToHost(host: HTMLElement): void {
  const theme = readEmbedThemeFromWindow();
  if (theme) {
    applyThemeTokens(host, theme);
  }
}

/**
 * Base Lit element that maps `window.LANDI_STORE_THEME` onto shadow :host CSS variables.
 * Required for dark page chrome (e.g. biohacks v1.2) where default light-theme tokens are invisible.
 */
export class LandiStorefrontElement extends LitElement {
  connectedCallback(): void {
    applyEmbedThemeToHost(this);
    super.connectedCallback();
  }
}
